import { useCustomSuspenseQuery } from "@/hooks/use-graphql-client";

import { RefundRequestList_RefundRequestTopPage_Query } from "./query";

type Props = {
	hotelID: string;
};

export const useFetchRefundRequestList = ({ hotelID }: Props) => {
	const { data } = useCustomSuspenseQuery(RefundRequestList_RefundRequestTopPage_Query, {
		variables: {
			hotelID,
		},
	});

	return {
		data,
	};
};
